export default __webpack_public_path__ + "static/media/jetbrains.37febf17.svg";